import { Component, ContentChild, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';

@Component({
  selector: 'nimbus-grid-column',
  templateUrl: './nimbus-grid-column.component.html',
  standalone: false,
})
export class NimbusGridColumnComponent implements OnChanges {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ContentChild(TemplateRef, { static: true }) public templateRef: TemplateRef<any>;

  @Input() public field: string;
  @Input() public title: string;
  @Input() public sortable: boolean = true;
  @Input() public width: number;
  @Input() public class: string;
  @Input() public headerClass: string;
  @Input() public textAlignment: 'right' | 'center' = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() public headerTemplateRef?: TemplateRef<any>;
  @Output() public widthChange = new EventEmitter<number>();

  public headerClasses: string;
  public classes: string;

  public ngOnChanges(e: SimpleChanges): void {
    if (e.class || e.textAlignment) {
      this.classes = this.textAlignment ? `column-${this.textAlignment} ${this.class}`.trim() : this.class;
    }
    if (e.headerClass || e.textAlignment) {
      this.headerClasses = this.textAlignment ? `column-${this.textAlignment} ${this.headerClass}`.trim() : this.headerClass;
    }

    if (e.width) {
      this.widthChange.emit(this.width);
    }
  }
}
